export const whitelistUin = [
  'o5PXlskc8i_fCi2uhJliOtJx0FDw',
  'o5PXlsqxmpFl2OTD7_Fho8wSwvhU',
  'o5PXlsiwoHPP7n5gB-IjmojdZlLo',
  'o5PXlsnyc607SRpIYYbSs2GgJ-6I',
  'o5PXlsk6gaf2m_fOlc47NI9f0fRs',
  'o5PXlsuGyehpRTyH8m2RZz4RAuF8',
  'o5PXlsi8JNpBfLghqpiAzmNiQ33Q',
  'o5PXlsnC3I8_cyW-KiKTvQ5YSXp8',
  'o5PXlsv0SanUJjNX9H4D6I1zvq1U',
  'o5PXlsiJW7Srk52r0ZcydKRudXBE',
  'o5PXlshzLIxY5cDM3M5XOxeqMJKM',
  'o5PXlss5GgRiLEhEbBkGYJ2DS8J8',
  'o5PXlsu5XVcdVtL3vjlZh9JlLMpc',
  'o5PXlsg4qRqfjTpYQB11F9r2wP0A',
  'o5PXlsj9XbFh92Nm8wZTN7uTR6eM',
  'o5PXlsrgRgtF6rb9FnYWAUeP511I',
  'o5PXlsjdwsvUBBlKVSscjEEvAEjI',
  'o5PXlshdjFn71pkw-8JHLRF5WrW8',
  'o5PXlsvRfgn54-A1WdHjudzzrGOg',
  'o5PXlspT0zUVoxuvuQRbUNrvv7OM',
  'o5PXlssLRC6VcGuUBKzSejd9sHzc',
  'o5PXlsu4OOtRa0FzcP-8p0BFENfs',
  'o5PXlsi7iw7YiCq8oT3N4QUsMZeY',
  'o5PXlslcvHKUwhq7_DpNdw7U6xRY',
  'o5PXlsjKZXuA_jY3vC-MqD9SO0TE',
  'o5PXlsg3Fh_Aizg86UFZVe1s97VQ',
  'o5PXlsswbtyCDsLZE3Z0f07wRJ8U',
  'o5PXlsvvMErjsCtRLxXLw5Zg258U',
  'o5PXlsstYBZ4x9yiPcaacwVufbhM',
  'o5PXlspq6HhNoyM0cW3QfE2becxU',
  'o5PXlstqDEv0vLWoqHPnLddSWVnc',
  'o5PXlsp8yUwIbDrzS8hyOf_j7bgQ',
  'o5PXlsvijXkp8MNbUuRdqRxno8o8',
  'o5PXlsiGpfkhnqRu4UsZIaZ9Y1wE',
  'o5PXlsv0F_FmSi2cdMJ-Nu1rZxrA',
  'o5PXlsmcQ4RwrTg7a9bU2gscUNAI',
  'o5PXlsiCSM0J-4Gbx_2CtgDfyYoM',
  'o5PXlsoCftdLKG-mFn0wNtNHpKXA',
  'o5PXlsleG_8sbWqvUExwJoRk930M',
  'o5PXlssvFfQhVO_c87ahEI5rkbas',
  'o5PXlsnImaYx6Ps6MrCMv2jzUva0',
  'o5PXlsgQvZ4aZzbLYFqPm0gBBxvg',
  'o5PXlsoQfmwZd4s5FLR0BFs1plek',
  'o5PXlsuACUMD7nCon6Il7fQQyMwo',
  'o5PXlsp607LkVM438wqgLyIVma1k',
  'o5PXlsuoTlfd636sHD0ZDNjlKHRg',
  'o5PXlsvl_SaH-yqeaa3hlfLAcSec',
  'o5PXlsolHO2cU-fzCo3qwNej-3bI',
  'o5PXlstI_x8pvXYullt3zVy5opKs',
  'o5PXlshnWcN_wq5tqzw7zxe2ydYU',
  'o5PXlsrkzNcMhiqj4kOk6J64wZV0',
  'o5PXlsnblSTkXtUDIev0ODwEh6So',
  'o5PXlsi_u_rFlgXw9yJxVaBgxNEw',
  'o5PXlsqoUdtMDhYiBXcyKo9zpYNk',
  'o5PXlsjLcKerujCEkS8OEuxHD6Go',
  'o5PXlslGlhgEuVmy7FF0TzpUeHIA',
  'o5PXlsuxhQo-SwL7MJUlLndmXhtM',
  'o5PXlspCFchlLzgQ9qRpEtj32mSY',
  'o5PXlsniO5cOz-dYZ4f-N1IzXr9w',
  'o5PXlsmfV96Xad37WCXNiNbBwLe8',
  'o5PXlsuSuto0ZyiH4r1GErtNl0ZU',
  'o5PXlsviS9Y9rJczLOvyIYuHHUXY',
  'o5PXlslPCCoVRxNiYgxtMOgz0bfA',
  'o5PXlsmOtTZTgP7_Ezd01IkkaXis',
  'o5PXlsi_u_rFlgXw9yJxVaBgxNEw',
];
